/* eslint-disable default-case */
import React from 'react';
import { containerConnect } from '@configuratorware/configurator-frontendgui/Framework/ComponentContainer';
import {
  RECEIVE_CONFIGURATION, RECEIVE_DESIGNER_DATA,
} from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';

import { actionTypes } from '@configuratorware/configurator-frontendgui/App/Reducers/DesignData/Actions';
import ResetRow from '../../Components/ResetRow';

const mapStateToProps = (state) => ({
  Component: ResetRow,
  originalConfigurationData: state.customConfigurator.originalConfigurationData,
  currentDesignData: state.designView, // state.customConfigurator.currentDesignData,
  currentDesignerData: state,
  configuratorState: state.configurator,
  globalState: state,
  isCreator: state.configurationMode.selectedMode === 'creator',
});
const mapDispatchToProps = (dispatch) => ({
  resetWithConfiguration: (globalState) => {
    Services.ui.show('globalLoader');
    let data = {};
    const stateNew = { ...globalState };
    switch (globalState.configurationMode.selectedMode) {
      case 'creator': {
        const designdata = globalState.configurator.configuration.designdata || {};
        data = {
          ...globalState.customConfigurator.originalConfigurationData,
          designdata,
        };

        stateNew.configurator.configuration = { ...globalState.customConfigurator.originalConfigurationData, designdata };
        dispatch({
          type: RECEIVE_CONFIGURATION,
          data,
        });
        dispatch({
          type: RECEIVE_DESIGNER_DATA,
          data: globalState.designView,
          globalState,
        });
        /* dispatch(
          selectOptionFromMainView(null),
        ); */
        Object.keys(globalState.configurator.configuration.designdata).forEach((key) => {
          dispatch({
            type: actionTypes.SET_CANVAS_DATA,
            canvasData: globalState.configurator.configuration.designdata[key].canvasData,
            designAreaIdentifier: key,
          });
        });

        // Services.designData.loadCanvasDataFromState();
        break;
      }
      case 'designer': {
        const stateDesign = { ...globalState };
        Object.keys(globalState.configurator.configuration.designdata).forEach((key) => {
          stateDesign.configurator.configuration.designdata[key].canvasData = null;
          // designProductionMethodIdentifier
          dispatch({
            type: actionTypes.SET_CANVAS_DATA,
            canvasData: null,
            designAreaIdentifier: key,
          });
          if (stateDesign.customDesignerData.initialDesignData[key]) {
            stateDesign.configurator.configuration.designdata[key].designProductionMethodIdentifier = stateDesign.customDesignerData.initialDesignData[key].designProductionMethodIdentifier;
            dispatch({
              type: actionTypes.SET_DESIGN_PRODUCTION_METHOD,
              designProductionMethodIdentifier: stateDesign.customDesignerData.initialDesignData[key].designProductionMethodIdentifier,
              designAreaIdentifier: key,
            });
          }
          Services.designData.loadCanvasDataFromState();
        });
        // stateNew = { ...globalState, configurator: stateDesign.configurator };
      }
    }
    /*
    dispatch({
      type: RECEIVE_CONFIGURATION,
      data: globalState.configurator,
    });

    console.log('DO SET', data);
    dispatch({
      type: RECEIVE_CONFIGURATION,
      data: globalState.configurator,
    });
    console.log('stateNew', stateNew);
    dispatch({
      type: RECEIVE_DESIGNER_DATA,
      data: stateNew.designView,
      globalState: stateNew,
    }); */

    Services.ui.hide('globalLoader');
  },
});
export default containerConnect(mapStateToProps, mapDispatchToProps);
